<button
  (click)="setShowDocumentsSettingsModal(true)"
  class="settings-button icon-only-button small"
  type="button"
  [title]="'pia.features.document-settings-modal.openButtonLabel' | translate"
>
  <claas-icon
    [iconId]="'648660'"
    [namespace]="'pia'"
    [size]="20"
    [alt]="''"
    [removeDefaultColor]="true"
  ></claas-icon>
</button>
<claas-aside-modal-dialog [(show)]="showDocumentsSettingsModal">
  <claas-document-settings-modal
    class="modal-content"
    data-document-settings-modal-overlay
    (closeSettings)="setShowDocumentsSettingsModal(false)"
  ></claas-document-settings-modal>
</claas-aside-modal-dialog>
